import { Link } from 'react-router-dom';

export function NotFound() {
  return (
    <div className="flex flex-1 flex-col items-center justify-center gap-3 p-10 text-center">
      <h1 className="text-lg font-semibold text-viana-primary">Nothing here</h1>
      <Link to="/" className="text-sm font-medium text-viana-secondary hover:underline">
        Back to the demo list
      </Link>
    </div>
  );
}
